export default {
    mounted(el, binding) {
        const clickOutside = ({target}) => {
            if (!(el == target || el.contains(target))) {
                binding.value()
            }
        }

        document.addEventListener('click', clickOutside)
        binding.onClickOutside = clickOutside
    },
    unmounted(_, binding) {
        document.removeEventListener('click', binding.onClickOutside)
    }
}


